////////////////////////////////////////
// # GOLDEN RULE!!!! HONOR ABOVE ALL!!!!
////////////////////////////////////////
// NO NEW FILES!!!!!!!!!
////////////////////////////////////////

// I. MANDATORY FILE HEADER
// ⚪ [Subsection 1: PURE WHITE] Rob, file path: /kings/home/primary/src/main/Main_SRC_Primary_Home_Kings.tsx
// ⚪ [Subsection 2: PURE WHITE] Rob, BitsBound Home Kingdom Main Entry Point - Revolutionary legal-to-code monolithic frontend!
// ⚪ [Subsection 3: PURE WHITE] Rob, Author: Rob Taylor - Solo Bootstrap Warrior!
// ⚪ [Subsection 4: PURE WHITE] Rob, Created: 2025-08-17
// ⚪ [Subsection 5: PURE WHITE] Rob, Version: 1.0.0 - Production-Ready <75μs Enforcement!

// II. ASCII FUNCTION FLOW DIAGRAM
/*
╔════════════════════════════════════════════════════════════════════════════════════════════╗
║                        HOME KINGDOM MAIN ENTRY POINT                                      ║
║                                                                                            ║
║    Browser → React App → Orchestration → UI Components → Legal Compliance                 ║
║       ↓          ↓            ↓              ↓               ↓                            ║
║    [Load]    [Mount]    [Frontautocrat]    [Pea/Pod]    [Enforcement]                    ║
║                                                                                            ║
║    Performance Targets:                                                                   ║
║    • Initial Load: <500ms                                                                 ║
║    • First Paint: <300ms                                                                  ║
║    • Interactive: <1000ms                                                                 ║
║    • Legal Check: <75μs                                                                   ║
╚════════════════════════════════════════════════════════════════════════════════════════════╝
*/

// III. IMPORTS
// 🟢 [Subsection 21: NEON GREEN] Rob, importing React for component foundation!
import React from 'react';
// 🟢 [Subsection 22: NEON GREEN] Rob, importing ReactDOM for browser rendering!
import ReactDOM from 'react-dom/client';
// 🟢 [Subsection 23: NEON GREEN] Rob, importing StrictMode for development checks!
import { StrictMode } from 'react';
// 🟢 [Subsection 23.1: NEON GREEN] Rob, importing Vercel Analytics for page view tracking!
import { Analytics } from '@vercel/analytics/react';
// 🟢 [Subsection 23.2: NEON GREEN] Rob, importing Vercel Speed Insights for Core Web Vitals!
import { SpeedInsights } from '@vercel/speed-insights/react';
// 🟢 [Subsection 24: NEON GREEN] Rob, importing Frontautocrat orchestration engine!
// import FrontautocratProvider from '../orchestration/frontautocrat/Frontautocrat_Orchestration_SRC_Primary_Home_Kings';
// 🟢 [Subsection 25: NEON GREEN] Rob, importing Homepage Pod - the main UI component!
import HomepagePod from '../homepage/lobby/pod/Bitsbound_Kings_Home_Primary_SRC_Homepage_Lobby_Pod.js';
// 🟢 [Subsection 25.1: NEON GREEN] Rob, importing About Pod - company about page!
import AboutPod from '../about/lobby/pod/Bitsbound_Kings_Home_Primary_SRC_About_Lobby_Pod.js';
// 🟢 [Subsection 25.2: NEON GREEN] Rob, importing Documentation Pod - customer documentation!
import DocumentationPod from '../documentation/lobby/pod/Bitsbound_Kings_Home_Primary_SRC_Documentation_Lobby_Pod.js';
// 🟢 [Subsection 25.3: NEON GREEN] Rob, importing Terms of Service Pod - legal terms page!
import TermsOfServicePod from '../terms-of-service/pod/Bitsbound_Kings_Home_Primary_SRC_TermsOfService_Pod.js';
// 🟢 [Subsection 25.4: NEON GREEN] Rob, importing Privacy Pod - privacy policy page!
import PrivacyPod from '../privacy/pod/Bitsbound_Kings_Home_Primary_SRC_Privacy_Pod.js';
// 🟢 [Subsection 25.45: NEON GREEN] Rob, importing Security Pod - security statement page!
import SecurityPod from '../security/pod/Bitsbound_Kings_Home_Primary_SRC_Security_Pod.js';
// 🟢 [Subsection 25.46: NEON GREEN] Rob, importing DPA Pod - data processing agreement page!
import DpaPod from '../dpa/pod/Bitsbound_Kings_Home_Primary_SRC_Dpa_Pod.js';
// 🟢 [Subsection 25.5: NEON GREEN] Rob, InstantDemo Pod temporarily disabled - directory not yet created!
// import { InstantDemoPod } from '../instant-demo/pod/Kings_Home_Primary_SRC_InstantDemo_Pod.js';
// 🟢 [Subsection 26: NEON GREEN] Rob, other pods to be imported as needed!
// import PublicDocumentationPod from '../public-documentation/pod/Kings_Home_Primary_SRC_PublicDocumentation_Pod.js';
// 🟢 [Subsection 28: NEON GREEN] Rob, importing Pricing Pod for /pricing route!
import PricingPod from '../pricing/lobby/pod/Bitsbound_Kings_Home_Primary_SRC_Pricing_Lobby_Pod.js';
// 🟢 [Subsection 28.1: NEON GREEN] Rob, importing The BAR blog pod for /bar route!
// DISABLED: Focusing on TPC instead of BAR
// import BoundAtRuntimeLobbyPod from '../bound-at-runtime/lobby/pod/Bitsbound_Kings_Home_Primary_SRC_BoundAtRuntime_Lobby_Pod.js';
// 🟢 [Subsection 28.3: NEON GREEN] Rob, importing Sales Receptionist chat widget!
import { Bitsbound_Kings_Home_Primary_SRC_Homepage_SubLevels_SalesReceptionist_Subpod } from '../homepage/sub-levels/sales-receptionist/subpod/Bitsbound_Kings_Home_Primary_SRC_Homepage_SubLevels_SalesReceptionist_Subpod.js';
// 🟢 [Subsection 28.2: NEON GREEN] Rob, importing The Pitch Practice pod for /pitch route!
// DISABLED: Pitch pod file doesn't exist
// import PitchLobbyPod from '../pitch/lobby/pod/Bitsbound_Kings_Home_Primary_SRC_Pitch_Lobby_Pod.js';

// BUBSA documentation, auth, logger, and global style imports removed — not currently in use

// IV. INDEPENDENT CONSTANTS
// 🟦 [Subsection 31: BRIGHT TEAL] Rob, defining root element ID for React mount point!
const ROOT_ELEMENT_ID: string = 'root';
// 🟦 [Subsection 32: BRIGHT TEAL] Rob, defining environment mode for conditional logic!
const ENV_MODE: string = import.meta.env.MODE || 'development';
// 🟦 [Subsection 33: BRIGHT TEAL] Rob, performance monitoring flag for metrics!
const ENABLE_PERFORMANCE: boolean = ENV_MODE === 'production';
// 🟦 [Subsection 34: BRIGHT TEAL] Rob, legal enforcement hex codes for compliance!
const LEGAL_HEX_CODES: Record<string, string> = {
  WHO: '#FFFFFF',   // Entity executing
  WHAT: '#f2f2f2',  // Action specification  
  WHEN: '#a5ace6',  // Temporal constraints
  WHOM: '#e3b498',  // Data categories
  WHY: '#000000'    // Legal basis
};
// 🟦 [Subsection 35: BRIGHT TEAL] Rob, performance thresholds for monitoring!
const PERFORMANCE_TARGETS: Record<string, number> = {
  FIRST_PAINT_MS: 300,
  INTERACTIVE_MS: 1000,
  LEGAL_CHECK_US: 75
};

// Frontend_Logger, AdvancedProfiler, ErrorTracker, and performance budgets removed — not yet created

// V. FUNCTION/CLASS NAME
// 🔵 [Subsection 41: ROYAL BLUE] Rob, main application initialization function!
function initializeHomeKingdom(): void {
  // Start performance profiling! ⚡
  // profiler.mark('initialization-start', { module: 'main' });
  console.info('🚀 BitsBound Home Kingdom initialization started', {
    environment: ENV_MODE,
    userAgent: navigator.userAgent,
    viewport: { width: window.innerWidth, height: window.innerHeight }
  });
  
  // Add breadcrumb for initialization! 🍞
  // errorTracker.addBreadcrumb({
  //   type: 'navigation',
  //   category: 'initialization',
  //   message: 'Starting Home Kingdom initialization',
  //   level: 'info'
  // });
  
  // VI. DECLARATIONS
  // 🟣 [Subsection 51: VIOLET] Rob, declaring root element reference!
  const rootElement: HTMLElement | null = document.getElementById(ROOT_ELEMENT_ID);
  
  // 🟣 [Subsection 52: VIOLET] Rob, declaring performance start time!
  const startTime: number = performance.now();
  
  // 🟣 [Subsection 53: VIOLET] Rob, declaring React root instance!
  let reactRoot: ReactDOM.Root | null = null;
  
  // VII. DEPENDENT CONSTANTS
  // 🟠 [Subsection 61: ORANGE] Rob, error boundary wrapper depends on environment!
  const useStrictMode: boolean = ENV_MODE === 'development';
  
  // 🟠 [Subsection 62: ORANGE] Rob, performance observer depends on flag!
  const performanceObserver: PerformanceObserver | null = ENABLE_PERFORMANCE 
    ? new PerformanceObserver(handlePerformanceEntries)
    : null;
  
  // VIII. OPERATIONS
  // 🔴 [Subsection 71: RED] Rob, validate root element exists!
  if (!rootElement) {
    // 🔴 [Subsection 72: RED] Rob, throw error if root not found!
    const error = new Error(`Root element with ID '${ROOT_ELEMENT_ID}' not found!`);
    console.error('Failed to find root element', { rootId: ROOT_ELEMENT_ID });
    // errorTracker.captureError(error, { critical: true });
    throw error;
  }
  
  console.debug('Root element found', { elementId: ROOT_ELEMENT_ID });
  
  // 🔴 [Subsection 73: RED] Rob, mark performance checkpoint!
  if (ENABLE_PERFORMANCE) {
    // 🔴 [Subsection 74: RED] Rob, record DOM ready time!
    performance.mark('dom-ready');
    // profiler.mark('dom-ready', { phase: 'initialization' });
  }
  
  // 🔴 [Subsection 75: RED] Rob, create React root instance!
  reactRoot = ReactDOM.createRoot(rootElement);
  console.debug('React root created successfully');
  
  // 🔴 [Subsection 76: RED] Rob, configure performance observer!
  if (performanceObserver) {
    // 🔴 [Subsection 77: RED] Rob, observe paint and layout metrics!
    performanceObserver.observe({ entryTypes: ['paint', 'layout-shift'] });
  }
  
  // IX. PRE-RENDER LOGIC
  // 🟡 [Subsection 81: YELLOW] Rob, prepare app component with conditional wrapper!
  // 🟡 [Subsection 82: YELLOW] Rob, implementing simple client-side routing with pricing support! 🚀
  const AppComponent = () => {
    // 🟡 [Subsection 83: YELLOW] Rob, determine which component to render based on URL path! 🗺️
    const pathname = window.location.pathname;
    let ComponentToRender = HomepagePod;

    // 🟢 [Subsection: NEON GREEN] Rob, routing to pricing page!
    if (pathname === '/pricing') {
      ComponentToRender = PricingPod;
    } else if (pathname === '/about') {
      // 🟢 [Subsection: NEON GREEN] Rob, routing to about page!
      ComponentToRender = AboutPod;
    } else if (pathname === '/documentation' || pathname === '/docs') {
      // 🟢 [Subsection: NEON GREEN] Rob, routing to customer documentation page!
      ComponentToRender = DocumentationPod;
    } else if (pathname.startsWith('/docs/')) {
      // 🟢 [Subsection: NEON GREEN] Rob, deep-linking to specific documentation section!
      // Extract section ID from URL (e.g., /docs/mcp -> mcp)
      const sectionId = pathname.replace('/docs/', '');
      ComponentToRender = () => React.createElement(DocumentationPod, { initialSection: sectionId });
    } else if (pathname === '/terms' || pathname === '/terms-of-service') {
      // 🟢 [Subsection: NEON GREEN] Rob, routing to terms of service page!
      ComponentToRender = TermsOfServicePod;
    } else if (pathname === '/privacy' || pathname === '/privacy-policy') {
      // 🟢 [Subsection: NEON GREEN] Rob, routing to privacy policy page!
      ComponentToRender = PrivacyPod;
    } else if (pathname === '/security') {
      // 🟢 [Subsection: NEON GREEN] Rob, routing to security statement page!
      ComponentToRender = SecurityPod;
    } else if (pathname === '/dpa' || pathname === '/data-processing-agreement') {
      // 🟢 [Subsection: NEON GREEN] Rob, routing to data processing agreement page!
      ComponentToRender = DpaPod;
    // Pitch, BUBSA, and BAR routes removed — not currently in use
    }

    // 🟡 [Subsection 87: YELLOW] Rob, wrap component in styled container with dark background! 🎨
    // 🟡 [Subsection 87.1: YELLOW] Rob, including Vercel Analytics & SpeedInsights for Google Ads campaign tracking!
    const MainContent = (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#0a0a0a'
      }}>
        <ComponentToRender />
        {/* Sales Receptionist Chat Widget - Floating overlay */}
        <Bitsbound_Kings_Home_Primary_SRC_Homepage_SubLevels_SalesReceptionist_Subpod />
        {/* Vercel Analytics - tracks page views automatically, integrates with Vercel dashboard */}
        <Analytics />
        {/* Vercel Speed Insights - tracks Core Web Vitals (LCP, FID, CLS) for SEO */}
        <SpeedInsights />
      </div>
    );

    // 🟡 [Subsection 88: YELLOW] Rob, return component with optional StrictMode wrapper! 🎯
    return useStrictMode ? (
      <StrictMode>
        {MainContent}
      </StrictMode>
    ) : (
      MainContent
    );
  };
  
  // 🟡 [Subsection 84: YELLOW] Rob, log initialization metrics!
  console.info(`BitsBound Home Kingdom initializing`, {
    mode: ENV_MODE,
    strictMode: useStrictMode,
    performanceMonitoring: ENABLE_PERFORMANCE
  });
  
  // 🟡 [Subsection 85: YELLOW] Rob, mark render start!
  if (ENABLE_PERFORMANCE) {
    // 🟡 [Subsection 86: YELLOW] Rob, record pre-render time!
    performance.mark('render-start');
    // profiler.mark('render-start', { phase: 'rendering' });
  }
  
  // Add breadcrumb before render! 🍞
  // errorTracker.addBreadcrumb({
  //   type: 'navigation',
  //   category: 'render',
  //   message: 'Starting React render',
  //   level: 'info'
  // });
  
  // X. RENDER/RETURN
  // ⚫ [Subsection 91: BLACK] Rob, render React application to DOM!
  reactRoot.render(<AppComponent />);
  
  // ⚫ [Subsection 92: BLACK] Rob, measure total initialization time!
  const initTime: number = performance.now() - startTime;
  // const initDuration = profiler.measure('initialization', 'initialization-start', 'render-start');
  
  // ⚫ [Subsection 93: BLACK] Rob, log successful initialization!
  console.info(`✅ Home Kingdom initialized successfully`, {
    initTime: `${initTime.toFixed(2)}ms`
    // profiledTime: `${initDuration.toFixed(2)}ms`,
    // performance: profiler.getReport()
  });
  
  // ⚫ [Subsection 94: BLACK] Rob, check performance against targets!
  if (initTime > PERFORMANCE_TARGETS.INTERACTIVE_MS) {
    // ⚫ [Subsection 95: BLACK] Rob, warn if performance target missed!
    console.warn(`Initialization exceeded target`, {
      actual: initTime,
      target: PERFORMANCE_TARGETS.INTERACTIVE_MS,
      exceeded: initTime - PERFORMANCE_TARGETS.INTERACTIVE_MS
    });
  }
}

// 🔵 [Subsection 42: ROYAL BLUE] Rob, performance entry handler function!
function handlePerformanceEntries(list: PerformanceObserverEntryList): void {
  // 🟠 [Subsection 71: ORANGE] Rob, iterate through performance entries!
  for (const entry of list.getEntries()) {
    // 🟠 [Subsection 72: ORANGE] Rob, log paint metrics!
    if (entry.entryType === 'paint') {
      // 🟠 [Subsection 73: ORANGE] Rob, record first contentful paint!
      console.debug(`Paint metric captured`, {
        name: entry.name,
        startTime: entry.startTime,
        duration: entry.duration
      });
      
      // Mark in profiler! ⚡
      // profiler.mark(entry.name, { startTime: entry.startTime });
      
      // Check against budget! 💰
      // if (entry.name === 'first-contentful-paint') {
      //   profiler.measure('first-paint', 'initialization-start', entry.name);
      // }
    }
  }
}

// 🔵 [Subsection 43: ROYAL BLUE] Rob, error boundary for graceful failures!
window.addEventListener('error', (event: ErrorEvent) => {
  // 🔴 [Subsection 71: RED] Rob, log critical errors!
  console.error('💀 Critical error in Home Kingdom', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    stack: event.error?.stack
  });
  
  // Capture with ErrorTracker! 🐛
  // errorTracker.captureError(event.error || event.message, {
  //   critical: true,
  //   source: 'window-error-handler'
  // });
  
  // 🔴 [Subsection 72: RED] Rob, show styled error overlay with refresh button!
  const errorOverlay = document.createElement('div');
  errorOverlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:#0a0a0a;display:flex;align-items:center;justify-content:center;z-index:99999;';
  errorOverlay.innerHTML = `
    <div style="text-align:center;color:white;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;padding:40px;">
      <h1 style="margin:0 0 16px 0;font-size:28px;">Something went wrong</h1>
      <p style="margin:0 0 24px 0;color:#888;font-size:16px;">We're sorry for the inconvenience. Please refresh to try again.</p>
      <button onclick="location.reload()" style="background:linear-gradient(135deg,#0066ff,#00d4ff);color:white;border:none;padding:14px 32px;border-radius:8px;cursor:pointer;font-size:16px;font-weight:600;">Refresh Page</button>
    </div>
  `;
  document.body.appendChild(errorOverlay);
});

// Add unhandled rejection handler! 🚨
window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  console.error('Unhandled promise rejection', {
    reason: event.reason,
    promise: event.promise
  });
  
  // errorTracker.captureError(event.reason, {
  //   type: 'unhandled-rejection',
  //   critical: false
  // });
});

// ⚫ [Subsection 96: BLACK] Rob, wait for DOM ready before initialization!
if (document.readyState === 'loading') {
  // ⚫ [Subsection 97: BLACK] Rob, add event listener for DOM ready!
  document.addEventListener('DOMContentLoaded', initializeHomeKingdom);
} else {
  // ⚫ [Subsection 98: BLACK] Rob, initialize immediately if DOM ready!
  initializeHomeKingdom();
}

// ⚫ [Subsection 99: BLACK] Rob, export initialization function for testing!
export { initializeHomeKingdom };

// ⚫ [Subsection 100: BLACK] Rob, default export for module compatibility!
export default initializeHomeKingdom;
